"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/no-cycle
const SlotCoverSnappingBase_1 = __importDefault(require("./SlotCoverSnappingBase"));
class DoorSlideTrackSnapping extends SlotCoverSnappingBase_1.default {
    constructor(viewer, coverComponent) {
        super(viewer, coverComponent);
        this.treshold = 1 / 32;
        this.defaultSlotSnappingObstructionDetectionStartOffsets.aboveSlot = this.treshold + 0.05;
    }
    getRaycastPos() {
        return [this.treshold + 0.05];
    }
}
exports.default = DoorSlideTrackSnapping;
